import axios from "../../config/axiosConfig";
import { MASTER_OPTIONS_REQUEST, MASTER_OPTIONS_REQUEST_FAILURE, GET_MASTER_OPTIONS, SET_ADD_MASTER_IN_OPTIONS, SET_UPDATE_MASTER_IN_OPTIONS,
    SET_ACCOUNTS_DATA_IN_OPTIONS, GET_MASTER_ALL_OPTIONS, SET_RELOAD_MASTER_PAYLOAD, TABLE_VERSION_SUCCESS
 } from "../types";
 import { MODULE_IDS } from '@/components/PermissionsContext';
 import { forIn } from "lodash";
 import dayjs from '@/utils/dayjs';

const getDataByCompany = (data, companyId) => {
    const dataByCompany = {};
    forIn(data || {}, (value, key) => {
        const values = key === 'states' ? [...(value || [])] : (value || []).filter((val) => val.Company_Id == companyId);
        dataByCompany[key] = values;
    })
    return dataByCompany;
}

export const getMasterOptions = (masters, commonMaster, makeLoaded) => {
  return async (dispatch, getState) => {
    try {
        dispatch({ type: MASTER_OPTIONS_REQUEST });
        const { auth } = getState();
        let params = {
            customerId: auth?.user?.Customer_Id,
            companyId: auth.company?.id,
            commonMaster: !!auth?.company?.Common_Master,
            commonBooks: !!commonMaster && !!auth?.company?.Common_Master,
            masters
        };
      
        return axios.get("/master-options/getAll", { params }).then((response) => {
            if (response.data) {
                if (commonMaster) {
                    dispatch({ type: GET_MASTER_ALL_OPTIONS, payload: response.data });
                    if (!!auth?.company?.Common_Master) {
                        const keys = Object.keys(response.data || {});
                        const dataValues = { ...(response.data || {} ) };
                        if (keys.includes('books')) {
                            const booksByCompany = getDataByCompany({ books: dataValues.books }, auth.company?.id);
                            dataValues.books = booksByCompany.books || []
                        }
                        dispatch({ type: GET_MASTER_OPTIONS, payload: dataValues });
                    } else {
                        dispatch({ type: GET_MASTER_OPTIONS, payload: response.data });
                    }
                } else {
                    dispatch({ type: GET_MASTER_OPTIONS, payload: response.data });
                }
            }
            if (makeLoaded) {
                dispatch({ type: SET_RELOAD_MASTER_PAYLOAD, payload: {
                        isLoaded: true,
                        lastFetchedAt: Date.now()
                    }
                })
            }
            return response;
        }).catch((error) => {
            console.error(error);
            dispatch({ type: MASTER_OPTIONS_REQUEST_FAILURE, error: error.message });
            throw error;
        });
        } catch (error) {
            console.error(error);
            dispatch({ type: MASTER_OPTIONS_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const getAccountMasterOptions = (commonMaster, makeLoaded) => {
  return async (dispatch, getState) => {
    try {
        dispatch({ type: MASTER_OPTIONS_REQUEST });
        const { auth } = getState();
        let params = {
            customerId: auth?.user?.Customer_Id,
            companyId: auth.company?.id,
            commonMaster: !!auth?.company?.Common_Master,
            commonBooks: !!commonMaster && !!auth?.company?.Common_Master,
            finStartDate: auth.finyear?.From_Date && dayjs(auth.finyear?.From_Date).format('YYYY-MM-DD'),
            masters: `${MODULE_IDS.ACCOUNT}`,
        };
        let ledgerAmount = {};
        let parties = [];
        let setLedger = false;
        let setParty = false;
        
        axios.get("/ledger-report/getPartiesLedgerAmount", { params }).then((res) => {
            ledgerAmount = res.data || {};
            setLedger = true;
            if (setParty) {
                if (parties?.length) {
                    for (let i = 0; i < parties.length ; i++) {
                        const id = parties[i]['id'];
                        parties[i]['ledgerAmount'] = ledgerAmount[id]?.openingBalance || 0;
                    }
                
                    if (commonMaster) {
                        dispatch({ type: GET_MASTER_ALL_OPTIONS, payload: { accounts: parties } });
                        dispatch({ type: GET_MASTER_OPTIONS, payload: { accounts: parties } });
                    } else {
                        dispatch({ type: GET_MASTER_OPTIONS, payload: { accounts: parties } });
                    }
                }
            }
        }).catch((error) => {
            console.error(error);
        });

        return axios.get("/master-options/getAll", { params }).then((response) => {
            const data = {...(response.data || {}) };
            if (data) {
                parties = [...(data?.accounts || [])];
                setParty = true;
                if (setLedger) {
                    for (let i = 0; i < parties.length ; i++) {
                        const id = parties[i]['id'];
                        parties[i]['ledgerAmount'] = ledgerAmount[id]?.openingBalance || 0;
                    }
                    data.accounts = parties;
                }
                if (commonMaster) {
                    dispatch({ type: GET_MASTER_ALL_OPTIONS, payload: data });
                    dispatch({ type: GET_MASTER_OPTIONS, payload: data });
                } else {
                    dispatch({ type: GET_MASTER_OPTIONS, payload: data });
                }
            }
            if (makeLoaded) {
                dispatch({ type: SET_RELOAD_MASTER_PAYLOAD, payload: {
                        isLoaded: true,
                        lastFetchedAt: Date.now()
                    }
                })
            }
            return response;
        }).catch((error) => {
            console.error(error);
            dispatch({ type: MASTER_OPTIONS_REQUEST_FAILURE, error: error.message });
            throw error;
        });
        } catch (error) {
            console.error(error);
            dispatch({ type: MASTER_OPTIONS_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const addMasterInOption = (name, data) => {
    return async (dispatch, getState) => {
        const { masters: { options } = {} } = getState();
        if (options && options[name]) {
            dispatch({ type: SET_ADD_MASTER_IN_OPTIONS, payload: { name, data } });
        }
    }
}

export const updateMasterInOption = (name, id, data) => {
    return async (dispatch, getState) => {
        const { masters: { options } = {} } = getState();
        if (options && options[name]?.length) {
            dispatch({ type: SET_UPDATE_MASTER_IN_OPTIONS, payload: { name, id, data } });
        }
    }
}

export const setAccountDataInOption = (data) => {
    return async (dispatch) => {
        dispatch({ type: SET_ACCOUNTS_DATA_IN_OPTIONS, payload: data });
    }
}

export const setResetLoadMasterOption = () => {
    return async (dispatch) => {
        dispatch({ type: SET_RELOAD_MASTER_PAYLOAD, payload: { isLoaded: false } });
        dispatch({ type: TABLE_VERSION_SUCCESS, payload: {} });
    }
}